import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Box, Typography, TextField, Button, CircularProgress } from '@mui/material';
import { Send as SendIcon, Preview as PreviewIcon } from '@mui/icons-material';
import TemplateSelector from './TemplateSelector';

const modules = {
  toolbar: {
    container: [
      [{ 'header': [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'script': 'sub'}, { 'script': 'super' }],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'indent': '-1'}, { 'indent': '+1' }],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'align': [] }],
      ['link', 'image', 'video'],
      ['code-block', 'blockquote'],
      ['clean']
    ]
  },
  clipboard: {
    matchVisual: false,
  }
};

const formats = [
  'header', 'bold', 'italic', 'underline', 'strike',
  'script', 'list', 'bullet', 'indent',
  'color', 'background', 'align',
  'link', 'image', 'video', 'code-block', 'blockquote'
];

const ComposeForm = ({
  subject, setSubject,
  editorHtml, setEditorHtml,
  quillRef,
  handlePreview,
  handleSendEmails,
  loading,
  recipients,
  selectedTemplate,
  handleTemplateChange,
  emailTemplates
}) => (
  <Box sx={{ background: 'white', boxShadow: 3, borderRadius: 3, p: { xs: 2, sm: 4 }, mb: 3, border: '1px solid #e3e8ee', maxWidth: 800, mx: 'auto' }}>
    <Typography variant="h6" gutterBottom sx={{ fontWeight: 700, color: '#1976d2' }}>Compose Email</Typography>
    <TemplateSelector
      templates={emailTemplates}
      selectedTemplate={selectedTemplate}
      onChange={handleTemplateChange}
    />
    <TextField
      fullWidth
      label="Subject"
      value={subject}
      onChange={e => setSubject(e.target.value)}
      sx={{ mb: 3 }}
      required
      InputProps={{ style: { fontWeight: 500, fontSize: 18, borderRadius: 8 } }}
      variant="outlined"
    />
    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>Email Content</Typography>
    <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 2, overflow: 'hidden', mb: 2, background: '#fafbfc', minHeight: 300 }}>
      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={editorHtml || ''}
        onChange={setEditorHtml}
        modules={modules}
        formats={formats}
        placeholder="Write your email content here..."
        style={{ minHeight: '250px', border: 'none', background: 'inherit' }}
      />
    </Box>
    <Button
      variant="outlined"
      onClick={handlePreview}
      startIcon={<PreviewIcon />}
      disabled={!editorHtml}
      sx={{ borderRadius: 2, fontWeight: 600, px: 3 }}
    >
      Preview
    </Button>
    <Button
      variant="contained"
      onClick={handleSendEmails}
      startIcon={loading ? <CircularProgress size={20} /> : <SendIcon />}
      disabled={loading || !subject || !editorHtml || recipients.length === 0}
      sx={{
        borderRadius: 2,
        fontWeight: 600,
        px: 3,
        background: 'linear-gradient(90deg, #1976d2 0%, #42a5f5 100%)',
        color: 'white',
        boxShadow: 2,
        '&:hover': { background: 'linear-gradient(90deg, #1565c0 0%, #1e88e5 100%)' }
      }}
    >
      {loading ? 'Sending...' : `Send to ${recipients.length} recipients`}
    </Button>
  </Box>
);

export default ComposeForm;